import importer from "common/importer";
const { chatbotReq: req } = importer("APIs", null);

export const getChatbotResponse = (recievedData) => {
  const data = {
    ...recievedData,
  };
  // Data includes below given:
  // inputText
  // localeId: "en_US",
  // sessionTimout: false
  // chatStarted
  // chatEnd

  return req.post(``, { data });
};
